export default __webpack_public_path__ + "static/Rectangle 1040-f325ad30cd5a9c063ff9dc363f7b16e3.png";